import { useState } from "react";
import { useTill } from "@/lib/till-context";
import { mediaUrl } from "@/lib/media";

/**
 * The store's logo at its own shape (wordmarks are wide), with a short label beside it.
 * `onDark` turns the logo white for graphite backgrounds; a logo that fails to load falls back
 * to the store's initial instead of an empty box.
 */
export function Brand({ big, sub, onDark = true, showName = false }: { big?: boolean; sub?: string; onDark?: boolean; showName?: boolean }) {
  const { store } = useTill();
  const [bad, setBad] = useState(false);
  const name = store?.storeName ?? "Store";
  const logo = store?.settings?.logo;
  const h = big ? 42 : 30;
  const subText = sub ?? "";
  return (
    <div className="flex min-w-0 items-center gap-3">
      {logo && !bad ? (
        <img src={mediaUrl(logo, 600)} alt={name} onError={() => setBad(true)} style={{ height: h, filter: onDark ? "brightness(0) invert(1)" : undefined }} className="w-auto max-w-[240px] flex-none object-contain" />
      ) : (
        <span style={{ width: h, height: h }} className="grid flex-none place-items-center bg-brand text-lg font-black text-white">
          {name.trim()[0]?.toUpperCase() ?? "S"}
        </span>
      )}
      {showName || !logo || bad ? (
        <span className="flex min-w-0 flex-col leading-tight">
          {!logo || bad ? <b className={big ? "truncate text-lg font-extrabold" : "truncate text-[13px] font-extrabold"}>{name}</b> : null}
          <span className={`truncate font-mono text-[11px] uppercase tracking-wider ${onDark ? "text-white/60" : "text-muted"}`}>{subText}</span>
        </span>
      ) : null}
    </div>
  );
}
